import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { BranchCategoryGridDataService } from 'common/services/data-services/admin/branch-category/branch-category-grid.service';
import { BranchCategoryModel } from 'common/models/page-models/branch-category/branch-category-data.model';
import { BranchCategoryGridMetaModel } from 'common/models/page-models/branch-category/branch-category-grid-meta.model';
import { BranchCategoryListingModel } from 'common/models/page-models/branch-category/branch-category-grid.model';


 
@Injectable({
    providedIn: 'root'
})
export class BranchCategoryGridWidgetService extends GridWidgetService<BranchCategoryModel, BranchCategoryListingModel> {
    constructor(protected override ds: BranchCategoryGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new BranchCategoryGridMetaModel().getMetaModel();
        return meta;
    }
}